import axios from 'axios'
import { getAuthSession } from '@/services/auth'

const prms = {
  baseURL: process.env.VUE_APP_API_URL,
  'Content-Type': 'application/json',
  Accept: 'application/json'
}

if (getAuthSession().authToken) {
  prms.headers = {
    Authorization: `Bearer ${getAuthSession().authToken}`
  }
}

export const axiosInstance = axios.create(prms)

export function downloadFile (url, label) {
  return axios.get(url, {
    responseType: 'blob'
  }).then(response => {
    const blob = new Blob([response.data], { type: 'application/pdf' })
    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = label
    link.click()
    URL.revokeObjectURL(link.href)
  })
}
